import React from 'react';
import { Box, Theme, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { Mention as MentionPillType } from '../../../Room/components/BuyerCopilotChats/MentionsNode/MentionPill';
import {
  MENTION_TOKEN_CAPTURE_REGEX,
  MENTION_TOKEN_SPLIT_REGEX,
} from '../../../Room/components/BuyerCopilotChats/MentionsNode/constants';

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    marginBottom: theme.spacing(0.5),
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
  messageText: {
    fontSize: 'var(--label-medium-accent-font-size)',
    lineHeight: 'var(--label-medium-accent-line-heigh)',
    display: 'inline',
  },
  messageTextWithMention: {
    fontSize: 'var(--label-medium-accent-font-size)',
    lineHeight: 'var(--label-medium-accent-line-heigh)',
    display: 'inline',
    color: 'var(--text-primary-light)',
    cursor: 'pointer',
    borderRadius: '100px',
    background: 'var(--mention-background)',
    margin: '0 4px',
    padding: '0 6px',
  },
}));

interface MessageProps {
  message: string;
  mentions?: MentionPillType[];
  onMentionClick?: (mention: MentionPillType) => void;
}

const Message: React.FC<MessageProps> = (props: MessageProps): JSX.Element => {
  const classes = useStyles();
  const { message, mentions, onMentionClick } = props;

  if (!mentions || mentions.length === 0) {
    return <Typography className={classes.messageText}>{message}</Typography>;
  }

  const parts = message.split(MENTION_TOKEN_SPLIT_REGEX);

  const segments = parts.map((part) => {
    const match = part.match(MENTION_TOKEN_CAPTURE_REGEX);
    if (match) {
      const mention = mentions.find((m) => m.uuid === match[1]);
      return { type: 'mention', content: `@${mention?.value}`, mention };
    }
    return { type: 'text', content: part };
  });

  return (
    <Box className={classes.container}>
      {segments.map((segment, index) => {
        if (segment.type === 'mention' && segment.mention) {
          return (
            <Typography
              key={segment.mention?.uuid || index}
              component="span"
              onClick={() => onMentionClick?.(segment.mention!)}
              className={classes.messageTextWithMention}
            >
              {segment.content}
            </Typography>
          );
        }
        return (
          <Typography
            key={
              segment.type === 'mention'
                ? segment.mention?.uuid
                : `text-${segment.content}`
            }
            component="span"
            className={classes.messageText}
          >
            {segment.content}
          </Typography>
        );
      })}
    </Box>
  );
};

export default Message;
